
import wx from 'weixin-js-sdk'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'

var interval1 = null; 
export default {
components: {
wx,XTextarea,Group
},
data() {
return {
popUp: false,
videoShow: false,
beforeShow: false,
afterShow: false,
beforeDow: false,
afterDow: true,
beforeValue:[],
afterValue:[],
code:'',
order:{},
from:{
beforeTitle:'',
beforeContent:'',
afterTitle: '',
afterContent: '',
beforePics:[],
afterPics:[],
beforeRecord:[],
afterRecord:[],
},
before:[],
after:[],
beforePicsPath:[],
afterPicsPath:[],
beforeRecordPath:[],
afterRecordPath:[],
record:0,
currentIndex: 0, // 当前音频的索引
isPlaying: false,  // 是否正在播放
audioFiles:[],
srcAudio:'',
srcAudioText:'',
recordText:'开始录音',
recordText1:'开始录音',
currentTime: 60,
}
},
created() {
this.config();
this.factoryConfirm();
this.cancelRecording(0);
this.cancelRecording(1);
},
methods: {
interval (i) {
let that = this;
let currentTime = 0;
interval1 = setInterval(function () {
currentTime++;
if(i > 0){
that.recordText1 = '录音中 '+currentTime + '秒';
}else{
that.recordText = '录音中 '+currentTime + '秒';
}
if (currentTime >= that.currentTime) {
clearInterval(interval1);
that.stopRecording(i);
if(i > 0){
that.recordText1 = '开始录音';
}else{
that.recordText = '开始录音';
}
}
}, 1000)
},

startRecording(i) {
this.interval(i);
this.record = i;
wx.startRecord();
},

stopRecording(i) {
this.record = i;
const that = this;
wx.stopRecord({
success: (res) => {
console.log('录音完成，localId:', res.localId);
clearInterval(interval1);
that.uploadAudio(res.localId);
if(i > 0){
that.recordText1 = '开始录音';
}else{
that.recordText = '开始录音';
}
},
fail: (err) => {
console.error('停止录音失败:', err);
}
});
},

cancelRecording(i) {
const that = this;
wx.stopRecord({
success: (res) => {
const localId = res.localId;
clearInterval(interval1);
if(i > 0){
that.recordText1 = '开始录音';
}else{
that.recordText = '开始录音';
}
console.log('取消录音，localId:', localId);
},
fail: (err) => {
console.error('取消录音失败:', err);
}
});
},

onVoiceRecordEnd() {
const that = this;
wx.onVoiceRecordEnd({

complete: function (res) {
console.log('超过一分钟自动完成，localId:', res.localId);
that.uploadAudio(res.localId);
}
});
},

startPlaying(i,val){
if(val > 0){
this.audioFiles = this.afterRecordPath;
}else{
this.audioFiles = this.beforeRecordPath;
}
this.currentIndex = i;
this.popUp = true;
this.videoShow = true;
this.isPlaying = true;
this.srcAudio = this.audioFiles.length > 0 ? this.audioFiles[this.currentIndex] : '';
this.srcAudioText = (this.currentIndex+1) +'、'+this.srcAudio.substr(this.srcAudio.lastIndexOf('/')+1,20);
this.playAudio();
},

removePlaying(index,val) {
const that = this;
this.$func.confirm('确认删除录音？','提示',()=>{
if(val > 0){
that.afterRecordPath.splice(index,1);
that.from.afterRecord.splice(index,1);
}else{
that.beforeRecordPath.splice(index,1);
that.from.beforeRecord.splice(index,1);
}
})
},

playAudio() {
const that = this;
wx.ready(function () {
let media = document.getElementById("musicBox");
media.src = that.srcAudio;
media.play();
});
},

playNextAudio() {
this.currentIndex++;
if (this.currentIndex < this.audioFiles.length) {
this.srcAudio = this.audioFiles.length > 0 ? this.audioFiles[this.currentIndex] : '';
this.srcAudioText = (this.currentIndex+1) +'、'+this.srcAudio.substr(this.srcAudio.lastIndexOf('/')+1,20);

this.playAudio();
} else {

this.isPlaying = false;
this.srcAudioText = '';
this.closePop();
console.log('All audios finished playing');
}
},
uploadAudio(localId) {
const that = this;
wx.uploadVoice({
localId: localId, // 录音的 localId
isShowProgressTips: 1, // 是否显示上传进度
success: (res) => {
that.$api.uploadsImgOss({serverId:res.serverId,path:'audio'}).then((res)=>{
if(res){
if(that.record > 0){
that.afterRecordPath.push(res.data.pathName);
that.from.afterRecord.push(res.data.saveName);
}else{
that.beforeRecordPath.push(res.data.pathName);
that.from.beforeRecord.push(res.data.saveName);
}
}
})
}
});
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['barCode'],
success: function (res) {
setTimeout(()=>{
that.code = res.resultStr.split(',')[1];
that.getOrder();
},300);
}
})
});
wx.error((res)=> {
console.log(res)
alert(res.errMsg);
})
},
factoryConfirm() {
this.$api.factoryConfirm({}).then((res)=>{
if(res){
this.before = res.data.before;
this.after = res.data.after;
}
})
},
openBeforeShow(){
this.popUp = true;
this.beforeShow = true;
},
openAfterShow(){
this.popUp = true;
this.afterShow = true;
},
closePop(){
this.popUp = false;
this.beforeShow = false;
this.afterShow = false;
this.videoShow = false;
wx.ready(function () {
let media = document.getElementById("musicBox");
media.pause();
});
},
beforeSelect(i){
const beforeValue = this.beforeValue;
if(beforeValue.indexOf(i) > -1){
beforeValue.splice(beforeValue.indexOf(i),1);
this.beforeValue = beforeValue;
}else{
this.beforeValue.push(i);
}

const beforeValue1 = this.beforeValue;
this.from.beforeTitle = '';
beforeValue1.forEach((item,index)=>{
this.from.beforeTitle += (index == beforeValue1.length-1 ? this.before[item].title : this.before[item].title+',');
});
if(beforeValue1.length < 1){
this.from.beforeTitle= '请选择';
}
},
afterSelect(i){
const afterValue = this.afterValue;
if(afterValue.indexOf(i) > -1){
afterValue.splice(afterValue.indexOf(i),1);
this.afterValue = afterValue;
}else{
this.afterValue.push(i);
}

const afterValue1 = this.afterValue;
this.from.afterTitle = '';
afterValue1.forEach((item,index)=>{
this.from.afterTitle += (index == afterValue1.length-1 ? this.after[item].title : this.after[item].title+',');
});
if(afterValue1.length < 1){
this.from.afterTitle= '请选择';
}
},
getOrder(){
let that = this;
if(!this.code){
that.$func.showToast('衣物条码无效');
return ;
}




that.$func.startLoading();
this.$api.barOrder({code:this.code}).then((res)=>{
if(res){
that.order = res.data;
that.$func.endLoading();
}
})
},
submit() {
console.log(this.from);
if(!this.code){
this.$func.showToast('输入衣物编码或扫码');
return false;
}
this.from.code = this.code;
this.$api.submitFactoryConfirm(this.from).then((res)=>{
if(res){
this.$func.showToast('提交成功');
setTimeout(()=>{
window.location.reload();
},300);
}
})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage", "uploadImage","scanQRCode",'startRecord', 'stopRecord','uploadVoice',
'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd'
]
});
}
})
},
uploadFile(index){
let that = this;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds,index);
}
});
},
uploadImg(localIds,index){
let that = this;
let localId = localIds.pop();
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImgOss({serverId:res.serverId,path:'record'}).then((res)=>{
if(res){
if(index > 0){
that.afterPicsPath.push(res.data.pathName);
that.from.afterPics.push(res.data.saveName);
}else{
that.beforePicsPath.push(res.data.pathName);
that.from.beforePics.push(res.data.saveName);
}
if(localIds.length > 0){
that.uploadImg(localIds,index);
}
}
})
}
});
},
showPic(i,arr) {
wx.previewImage({
current: arr[i],
urls: arr
});
},
delImg(index,val){
if(val > 0){
this.afterPicsPath.splice(index,1);
this.from.afterPics.splice(index,1);
}else{
this.beforePicsPath.splice(index,1);
this.from.beforePics.splice(index,1);
}
},

}
}



// WEBPACK FOOTER //
// ./src/pages/clothesFactoryConfirmCreate.vue